import styled from "styled-components";
import { maxSize } from "../../Utils/common";
import { STYLE_TYPE, themeColor } from "../../Utils/magicStrings";

export const ReserveModalWrapper = styled('div')`
    position: relative;
    background: #F8F5F1;
    ${props => maxSize(500, props.styleType, 'width', 375)}; 
    ${props => maxSize(742, props.styleType, 'height', 520)};
`;

export const MainTextTitle = styled('div')`
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    text-align: center;
    ${props => maxSize(56, props.styleType, 'top', 24)};
    ${props => maxSize(500, props.styleType, 'width', 375)}; 
    ${props => maxSize(24, props.styleType, 'font-size', 14)};
    color: ${props => props.isError ? '#C98181' : 'black'};
`;

export const SubTextTitle = styled('div')`
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    text-align: center;
    ${props => maxSize(500, props.styleType, 'width', 375)}; 
    ${props => maxSize(95, props.styleType, 'top', 48)};
    ${props => maxSize(16, props.styleType, 'font-size', 14)};
    color: ${themeColor};
`;

export const TextFieldWrapper = styled('div')`
    position: absolute;
    ${props => maxSize(40, props.styleType, 'left', 28)};
    ${props => maxSize(119, props.styleType, 'top', 76)}; 
`;

export const TextItemWrapper = styled('div')`
    ${props => maxSize(16, props.styleType, 'margin-bottom', 12)}; 
`;

export const TextItemTitle = styled('div')`
    ${props => maxSize(14, props.styleType, 'font-size', 10)};
    ${props => maxSize(8, props.styleType, 'margin-bottom', 8)};
    display: flex;
    align-items: center;
    span#point {
        display: inline-block;
        ${props => maxSize(8, props.styleType, 'margin-left', 8)};
        ${props => maxSize(6, props.styleType, 'width', 6)}; 
        ${props => maxSize(6, props.styleType, 'height', 6)}; 
        border-radius: 50%;
        background-color: ${props => props.hasText ? themeColor : '#BA5B5B'};
    }
    span#text {
        display: inline-block;
        color: ${props => props.hasText ? themeColor : '#BA5B5B'};
        ${props => maxSize(4, props.styleType, 'margin-left', 4)};
        ${props => maxSize(10, props.styleType, 'font-size', 8)};
    }
`;

export const TextItemInput = styled('div')`
    ${props => maxSize(8, props.styleType, 'margin-top', 8)};
    ${props => maxSize(420, props.styleType, 'width', 318)}; 
    ${props => maxSize(55, props.styleType, 'height', 42)}; 
    border-radius: 4px;
    overflow: hidden;
`;

export const ConfirmButton = styled('div')`
    position: absolute;
    background: #D1BB8B;
    ${props => {
        if(props.styleType !== STYLE_TYPE.MOBILE) {
            return `
                border-radius: 35px;
                ${maxSize(134, props.styleType, 'left', 28)};
                ${maxSize(56, props.styleType, 'bottom', 76)}; 
                ${maxSize(241, props.styleType, 'width', 318)}; 
                ${maxSize(70, props.styleType, 'height', 42)}; 
            `
        } else {
            return `
                left: 0;
                bottom: 0;
                ${maxSize(375, props.styleType, 'width', 375)}; 
                ${maxSize(56, props.styleType, 'height', 56)}; 
            `;
        }
    }}
    
    ${props => maxSize(24, props.styleType, 'font-size', 18)};
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const CloseButton = styled('div')`
    position: absolute;
    ${props => maxSize(461, props.styleType, 'left', 334)};
    ${props => maxSize(24, props.styleType, 'top', 24)}; 
    ${props => maxSize(15, props.styleType, 'width', 15)}; 
    ${props => maxSize(15, props.styleType, 'height', 15)}; 
    z-index: 4;
    & img {
        width: 100%;
        height: 100%;
    }
`;

export const MobileButtomDialog = styled('div')`
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 100;
    ${props => maxSize(15, props.styleType, 'width', 375)}; 
    ${props => maxSize(15, props.styleType, 'height', 520)}; 
`;